import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreTypePipe } from './store-type/store-type.pipe';
import { BusinessTypeToIconPipe } from './business-type-to-icon/business-type-to-icon.pipe';

@NgModule({
  declarations: [
    StoreTypePipe,
    BusinessTypeToIconPipe,
  ],
  exports: [
    StoreTypePipe,
    BusinessTypeToIconPipe,
  ],
  imports: [CommonModule],
})
export class PipesModule {}

